<template>
  <div id="app">
    <MainNav />
    <router-view class="router_view" />
    <MainFooter />
  </div>
</template>

<script>
import AOS from 'aos'
import MainNav from "@/components/MainNav"
import MainFooter from "@/components/MainFooter"
export default {
  name: "App",
  components: {
    MainNav,
    MainFooter
  },
  data() {
    return {}
  },
  created() {
    AOS.init()
    window.addEventListener('load', () => {
      AOS.init()
    })
  },
  watch: {
    $route() {
      AOS.refresh()
    },
  },
}
</script>

<style lang="scss" src="@/assets/css/app.scss"></style>
